export function updateTooltip() {
    const dataToolTips = document.querySelectorAll(
        '[data-tooltip-top], [data-tooltip-right], [data-tooltip-bottom], [data-tooltip-left]'
    )
    const toolTipsClick = document.querySelectorAll('[data-tooltip-copy]')

    function getTooltipText(element) {
        return (
            element.dataset.tooltipTop ||
            element.dataset.tooltipRight ||
            element.dataset.tooltipBottom ||
            element.dataset.tooltipLeft
        )
    }

    dataToolTips.forEach((dataTooltip) => {
        if (!dataTooltip.querySelector('.tooltip')) {
            const tooltipText = `<span class="tooltip">${getTooltipText(dataTooltip)}</span>`
            dataTooltip.insertAdjacentHTML('afterbegin', tooltipText)
        }
    })

    toolTipsClick.forEach((toolTipClick) => {
        toolTipClick.addEventListener('click', function () {
            const tooltip = toolTipClick.querySelector('.tooltip')
            const originalText = getTooltipText(toolTipClick)
            tooltip.textContent = toolTipClick.dataset.tooltipCopy
            setTimeout(() => {
                tooltip.textContent = originalText
            }, 1000)
        })
    })
}

document.addEventListener('DOMContentLoaded', updateTooltip)
